import React, { useState } from 'react';

import AffiliatesApi from '../../../Api/CRM/Modules/AffiliatesApi';
import Affiliate from '../../../Api/Models/Affiliate';
import CasinoAffiliateCommissions from '../../casino/elements/Affiliates/CasinoAffiliateCommissions';
import ActionButton from '../../elements/ActionButton';
import { IS_CASINO_ENABLED } from '../../helpers/Constants';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import { ROLES } from '../../services/AdminPolicyService';
import PromoCodeTableAffiliate from '../promoCodes/PromoCodeTableAffiliate';
import UsersList from '../user/UsersList';

import AffiliateDetails from './AffiliateDetails';
import AffiliateRevenuePercentageList from './AffiliateRevenuePercentageList';
import AffiliateStatistics from './AffiliateStatistics';

import useAffiliateRevenueAuth from 'crm/hooks/useAffiliateRevenueAuth';

function AffiliateShow() {
    const { id } = useNumberParams();
    const [affiliate, setAffiliate] = useState<Affiliate>();
    const url = `/crea/api/affiliate/${id}`;
    const affUrl = `/affiliate/${id}`;
    const hasAffiliateRevenueAccess = useAffiliateRevenueAuth();

    const getAffiliate = () => AffiliatesApi.getById(id).then(setAffiliate);

    useOnce(getAffiliate);

    if (!affiliate) {
        return null;
    }

    return (
        <>
            {affiliate.doesntHaveAdmin() && (
                <ActionButton url={`${affUrl}/attach/admin`} title="Attach Admin" roles={ROLES.MAIN_ADMINS} />
            )}
            <AffiliateDetails affiliate={affiliate} url={url} getAffiliate={getAffiliate} />
            <AffiliateStatistics url={url} />
            <UsersList short cardTitle="Users" source="affiliates" relatedId={id} />
            {IS_CASINO_ENABLED && <CasinoAffiliateCommissions />}
            <PromoCodeTableAffiliate affiliateId={id} />
            {affiliate.doesntHaveAdmin() && hasAffiliateRevenueAccess && <AffiliateRevenuePercentageList id={id} />}
        </>
    );
}

export default AffiliateShow;
